import { render } from "./CampLocationMgmt.vue?vue&type=template&id=c4155ff2"
import script from "./CampLocationMgmt.vue?vue&type=script&lang=js"
export * from "./CampLocationMgmt.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__